module.exports = __webpack_public_path__ + "ky.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ky.svg
// module id = 905
// module chunks = 0